// CSV utilities for Accounting Recap
export type RecapType = "stripe" | "cash" | "booking";

export const toCSV = (rows: any[], separator = ";"): string => {
  if (!rows || rows.length === 0) return "";
  const headers = Object.keys(rows[0]);
  const escape = (val: any) => {
    if (val === null || val === undefined) return "";
    const str = String(val);
    const needsQuotes = str.includes(separator) || str.includes("\n") || str.includes('"');
    const escaped = str.replace(/\"/g, '""');
    return needsQuotes ? `"${escaped}"` : escaped;
  };
  const headerLine = headers.map(escape).join(separator);
  const lines = rows.map((row) => headers.map((h) => escape((row as any)[h])).join(separator));
  return [headerLine, ...lines].join("\n");
};

export const downloadCSV = (csv: string, filename: string) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Build CSV rows with labels identical to the visual table headers and same date strings
export const buildCsvRowsForRestaurant = (
  rest: any,
  params: {
    recap: RecapType;
    year: string;
    month: string;
    cashTransactionsDetail?: any[] | null;
    stripeTransactionsDetail?: any[] | null;
    bookingsDetail?: any[] | null;
  }
): any[] => {
  const { recap, year, month, cashTransactionsDetail, stripeTransactionsDetail, bookingsDetail } = params;

  const meta = {
    "Anno": year,
    "Mese": month,
    "Ristorante ID": rest?.id,
    "Nome Ristorante": rest?.name,
    "P.IVA Ristorante": rest?.piva ?? "",
  } as const;

  if (recap === "cash") {
    const list = cashTransactionsDetail ?? [];
    return list.map((t: any) => ({
      ...meta,
      "Ordine ID": t.order_id,
      "Totale": t.order_total,
      "Quantità": t.order_quantity,
      "Tavolo": t.table,
      "Commissione MyCIA": t.mycia_commission,
      "Data": t.created_at,
    }));
  }

  if (recap === "stripe") {
    const list = stripeTransactionsDetail ?? [];
    return list.map((t: any) => ({
      ...meta,
      "Transazione ID": t.transaction_id,
      "Totale": t.total_amount,
      "Importo Netto": t.net_amount,
      "Commissione MyCIA": t.mycia_commission,
      "Data": t.created_at,
    }));
  }

  const list = bookingsDetail ?? [];
  return list.map((t: any) => ({
    ...meta,
    "Prenotazione Giorno": t.reserved_at,
    "Prenotazione Ora": t.reserved_time,
    "Posti": t.seats,
    "Commissione MyCIA": t.mycia_commission,
  }));
};
